import React from 'react';
import { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import ListConcurso from '../../../components/rh/concurso/listar';


function ConcursoScreen() {
    return (
        <Fragment>
            <Head titulo="Concurso Público de 2012" />
            <Header />
            <Container>
                <ListConcurso />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ConcursoScreen;